export default "__VITE_ASSET__92b726cc__"